"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("./styles/styles");
exports.MetricDot = function (props) {
    var x = props.x, y = props.y;
    return (React.createElement("g", null,
        React.createElement("circle", { cx: x, cy: y, r: 5, fill: styles_1.MetricBlue, stroke: 'white' }),
        React.createElement("circle", { cx: x, cy: y, r: 7, fill: styles_1.MetricBlue, opacity: 0.2 })));
};
//# sourceMappingURL=MetricDot.js.map